export default __webpack_public_path__ + "static/media/element_spec_61.fd761514.webp";